import { Services, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'

import { icons, permissionPresets } from '@/utils'

const reportManagerQueueViaPoint = getServiceNameViaPoint(Services['report-manager/queue'])
const reportManagerRecurrentViaPoint = getServiceNameViaPoint(Services['report-manager/recurrent'])
const otpSettingsWidgetsViaPoint = getServiceNameViaPoint(Services['otp-settings/widgets'])
const otpSettingsChannelsViaPoint = getServiceNameViaPoint(Services['otp-settings/channels'])
const otpSettingsTemplatesViaPoint = getServiceNameViaPoint(Services['otp-settings/templates'])

const reportManagerQueuePermission = `advanced.${reportManagerQueueViaPoint}.get`
const reportManagerRecurrentPermission = `advanced.${reportManagerRecurrentViaPoint}.get`
const reportManagerPermissions = [
  reportManagerQueuePermission,
  reportManagerRecurrentPermission
]
const reportManagerPermissionsAccept = permissionPresets.meUp

const otpSettingsPermissions = [
  `advanced.${otpSettingsWidgetsViaPoint}.get`,
  `advanced.${otpSettingsChannelsViaPoint}.create`,
  `advanced.${otpSettingsTemplatesViaPoint}.create`
]

const urlShortenerSettingsDomainsViaPoint = getServiceNameViaPoint(Services['url-shortener-settings/domains'])
const urlShortenerSettingsPresetsViaPoint = getServiceNameViaPoint(Services['url-shortener-settings/presets'])

const urlShortenerPermissions = [
  `advanced.${Services['url-shortener']}.get`,
  `advanced.${urlShortenerSettingsDomainsViaPoint}.get`,
  `advanced.${urlShortenerSettingsPresetsViaPoint}.get`,
  `advanced.${Services['url-shortener-tracking']}.get`
]

export default [
  // general
  {
    path: '/',
    name: 'general',
    redirect: '/create',

    meta: {
      nav: true,
      navType: 'subheader'
    }
  },

  // create
  {
    path: '/create',
    name: 'create',
    component: () => {
      return import('@/pages/SendingsCreate')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'add_circle_outline',
      permission: 'advanced.sendings.generate',
      permissionAccept: true
    }
  },

  // sendings
  {
    path: '/sendings',
    name: 'sendings',
    component: () => {
      return import('@/pages/Sendings')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'swap_horiz',
      permission: 'advanced.sendings.get',
      permissionAccept: permissionPresets.meUp
    }
  },

  // billings
  {
    path: '/billings',
    name: 'billings',
    component: () => {
      return import('@/pages/Billings')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'attach_money',
      permission: 'advanced.billings.find', // Исключение, так как нет права ME на GET
      permissionAccept: permissionPresets.meUp
    }
  },

  // report-manager
  {
    path: `/${Services['report-manager']}`,
    name: Services['report-manager'],
    component: () => {
      return import('@/pages/report-manager')
    },

    meta: {
      auth: true,
      nav: true,
      navType: 'group',
      navIcon: icons.apps,
      permission: reportManagerPermissions,
      permissionAccept: reportManagerPermissionsAccept
    },

    children: [
      {
        path: 'queue',
        name: reportManagerQueueViaPoint,
        component: () => {
          return import('@/pages/report-manager/queue')
        },

        meta: {
          auth: true,
          nav: true,
          pathToTitle: reportManagerQueueViaPoint,
          permission: reportManagerQueuePermission,
          permissionAccept: reportManagerPermissionsAccept,
          originalServiceName: Services['report-manager/queue']
        },

        children: [
          {
            path: ':id',
            name: `${reportManagerQueueViaPoint}.single`,

            meta: {
              auth: true,
              permission: reportManagerQueuePermission,
              permissionAccept: reportManagerPermissionsAccept
            }
          }
        ]
      },
      {
        path: 'recurrent',
        name: reportManagerRecurrentViaPoint,
        component: () => {
          return import('@/pages/report-manager/recurrent')
        },

        meta: {
          auth: true,
          nav: true,
          pathToTitle: reportManagerRecurrentViaPoint,
          permission: reportManagerRecurrentPermission,
          permissionAccept: reportManagerPermissionsAccept,
          originalServiceName: Services['report-manager/recurrent']
        },

        children: [
          {
            path: ':id',
            name: `${reportManagerRecurrentViaPoint}.single`,

            meta: {
              auth: true,
              permission: reportManagerRecurrentPermission,
              permissionAccept: reportManagerPermissionsAccept
            }
          }
        ]
      }
    ]
  },

  // contacts
  {
    path: '/contacts',
    name: 'contacts',
    component: () => {
      return import('@/pages/Contacts')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'contact_phone',
      permission: 'advanced.contacts.get',
      permissionAccept: permissionPresets.meUp
    },

    children: [
      {
        path: ':id',
        name: 'contacts.single',

        meta: {
          auth: true,
          permission: 'advanced.contacts.get',
          permissionAccept: permissionPresets.meUp
        }
      }
    ]
  },

  // sendernames
  {
    path: '/sendernames',
    name: 'sendernames',
    component: () => {
      return import('@/pages/SenderNames')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'article',
      permission: 'advanced.sendernames.get',
      permissionAccept: permissionPresets.meUp
    },

    children: [
      {
        path: ':id',
        name: 'sendernames.single',

        meta: {
          auth: true,
          permission: 'advanced.sendernames.get',
          permissionAccept: permissionPresets.meUp
        }
      }
    ]
  },

  // patterns
  {
    path: '/patterns',
    name: 'patterns',
    component: () => {
      return import('@/pages/Patterns')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'developer_board',
      permission: 'advanced.patterns.get',
      permissionAccept: permissionPresets.resellerUp
    },

    children: [
      {
        path: ':id',
        name: 'patterns.single',

        meta: {
          auth: true,
          permission: 'advanced.patterns.get',
          permissionAccept: permissionPresets.resellerUp
        }
      }
    ]
  },

  // invoices
  {
    path: '/invoices',
    name: 'invoices',
    component: () => {
      return import('@/pages/Invoices')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'document_scanner',
      permission: 'advanced.invoices.get',
      permissionAccept: permissionPresets.meUp
    },

    children: [
      {
        path: ':id',
        name: 'invoices.single',

        meta: {
          auth: true,
          permission: 'advanced.invoices.get',
          permissionAccept: permissionPresets.meUp
        }
      }
    ]
  },

  // otp-settings
  {
    path: `/${Services['otp-settings']}`,
    name: Services['otp-settings'],
    component: () => {
      return import('@/pages/OTP')
    },

    meta: {
      auth: true,
      nav: true,
      navType: 'group',
      navIcon: '123',
      permission: otpSettingsPermissions,
      permissionAccept: permissionPresets.meUp
    },

    children: [
      {
        path: 'widgets',
        name: otpSettingsWidgetsViaPoint,
        component: () => {
          return import('@/pages/OTP/widgets')
        },

        meta: {
          auth: true,
          nav: true,
          pathToTitle: otpSettingsWidgetsViaPoint,
          permission: `advanced.${otpSettingsWidgetsViaPoint}.get`,
          permissionAccept: permissionPresets.meUp
        },

        children: [
          {
            path: ':id',
            name: `${otpSettingsWidgetsViaPoint}.single`,

            meta: {
              auth: true,
              permission: `advanced.${otpSettingsWidgetsViaPoint}.get`,
              permissionAccept: permissionPresets.meUp
            }
          }
        ]
      },
      {
        path: 'channels',
        name: otpSettingsChannelsViaPoint,
        component: () => {
          return import('@/pages/OTP/channels')
        },

        meta: {
          auth: true,
          nav: true,
          pathToTitle: otpSettingsChannelsViaPoint,
          permission: `advanced.${otpSettingsChannelsViaPoint}.get`,
          permissionAccept: permissionPresets.true
        },

        children: [
          {
            path: ':id',
            name: `${otpSettingsChannelsViaPoint}.single`,

            meta: {
              auth: true,
              permission: `advanced.${otpSettingsChannelsViaPoint}.get`,
              permissionAccept: permissionPresets.true
            }
          }
        ]
      },
      {
        path: 'templates',
        name: otpSettingsTemplatesViaPoint,
        component: () => {
          return import('@/pages/OTP/templates')
        },

        meta: {
          auth: true,
          nav: true,
          pathToTitle: otpSettingsTemplatesViaPoint,
          permission: `advanced.${otpSettingsTemplatesViaPoint}.get`,
          permissionAccept: permissionPresets.true
        },

        children: [
          {
            path: ':id',
            name: `${otpSettingsTemplatesViaPoint}.single`,

            meta: {
              auth: true,
              permission: `advanced.${otpSettingsTemplatesViaPoint}.get`,
              permissionAccept: permissionPresets.true
            }
          }
        ]
      }
    ]
  },

  // url-shortener
  {
    path: '/links',
    name: 'links',
    component: () => {
      return import('@/pages/Links')
    },
    redirect: '/links',

    meta: {
      auth: true,
      nav: true,
      navType: 'group',
      navIcon: 'link',
      permission: urlShortenerPermissions,
      permissionAccept: permissionPresets.meUp
    },

    children: [
      {
        path: 'domains',
        name: urlShortenerSettingsDomainsViaPoint,
        component: () => {
          return import('@/pages/UrlShortenerSettings/domains')
        },

        meta: {
          auth: true,
          nav: true,
          navOrder: 2,
          permission: `advanced.${urlShortenerSettingsDomainsViaPoint}.get`,
          permissionAccept: permissionPresets.meUp
        },

        children: [
          {
            path: ':id',
            name: `${urlShortenerSettingsDomainsViaPoint}.single`,

            meta: {
              auth: true,
              permission: `advanced.${urlShortenerSettingsDomainsViaPoint}.get`,
              permissionAccept: permissionPresets.meUp
            }
          }
        ]
      },

      {
        path: 'presets',
        name: urlShortenerSettingsPresetsViaPoint,
        component: () => {
          return import('@/pages/UrlShortenerSettings/presets')
        },

        meta: {
          auth: true,
          nav: true,
          navOrder: 3,
          permission: `advanced.${urlShortenerSettingsPresetsViaPoint}.get`,
          permissionAccept: permissionPresets.meUp
        },

        children: [
          {
            path: ':id',
            name: `${urlShortenerSettingsPresetsViaPoint}.single`,

            meta: {
              auth: true,
              permission: `advanced.${urlShortenerSettingsPresetsViaPoint}.get`,
              permissionAccept: permissionPresets.meUp
            }
          }
        ]
      },

      {
        path: 'tracking',
        name: Services['url-shortener-tracking'],
        component: () => {
          return import('@/pages/UrlShortenerTracking')
        },

        meta: {
          auth: true,
          nav: true,
          navOrder: 4,
          permission: `advanced.${Services['url-shortener-tracking']}.get`,
          permissionAccept: permissionPresets.meUp
        },

        children: [
          {
            path: ':id',
            name: `${Services['url-shortener-tracking']}.single`,

            meta: {
              auth: true,
              permission: `advanced.${Services['url-shortener-tracking']}.get`,
              permissionAccept: permissionPresets.meUp
            }
          }
        ]
      },

      {
        path: '',
        name: Services['url-shortener'],
        component: () => {
          return import('@/pages/UrlShortener')
        },

        meta: {
          auth: true,
          nav: true,
          navOrder: 1,
          pathToTitle: 'links.short',
          permission: `advanced.${Services['url-shortener']}.get`,
          permissionAccept: permissionPresets.meUp
        },

        children: [
          {
            path: ':id',
            name: `${Services['url-shortener']}.single`,

            meta: {
              auth: true,
              permission: `advanced.${Services['url-shortener']}.get`,
              permissionAccept: permissionPresets.meUp
            }
          }
        ]
      }
    ]
  },

  // admin
  {
    path: '/admin',
    name: 'admin',
    component: () => {
      return import('@/pages/Admin')
    },

    meta: {
      auth: true,
      nav: true,
      navType: 'subheader',
      permission: [
        'advanced.providers.get',
        'advanced.providerGroups.get',
        'advanced.routingRules.get',
        'advanced.routingGroups.get',
        'advanced.sendingsModeration.get',
        'advanced.dictionaries.get',
        'advanced.users.get',
        'advanced.tariffs.get',
        'advanced.requisites.get',
        'advanced.settingsSite.get'
      ],
      permissionAccept: permissionPresets.resellerUp
    },

    children: [
      {
        path: 'users',
        name: 'users',
        component: () => {
          return import('@/pages/Users')
        },

        meta: {
          auth: true,
          nav: true,
          navIcon: 'account_circle',
          permission: 'advanced.users.get',
          permissionAccept: permissionPresets.resellerUp
        },

        children: [
          {
            path: ':id',
            name: 'users.single',

            meta: {
              auth: true,
              permission: 'advanced.users.get',
              permissionAccept: permissionPresets.resellerUp
            }
          }
        ]
      },

      {
        path: 'tariffs',
        name: 'tariffs',
        component: () => {
          return import('@/pages/Tariffs')
        },

        meta: {
          auth: true,
          nav: true,
          navIcon: 'donut_large',
          permission: 'advanced.tariffs.get',
          permissionAccept: permissionPresets.resellerUp
        },

        children: [
          {
            path: ':id',
            name: 'tariffs.single',

            meta: {
              auth: true,
              permission: 'advanced.tariffs.get',
              permissionAccept: permissionPresets.resellerUp
            }
          }
        ]
      },

      {
        path: 'payments',
        name: 'payments',
        component: () => {
          return import('@/pages/Payments')
        },

        meta: {
          auth: true,
          nav: true,
          navIcon: 'attach_money',
          permission: [ 'advanced.payments.get', 'advanced.recurrentPayments.get' ],
          permissionAccept: permissionPresets.resellerUp
        }
      },

      {
        path: 'sendingsModeration',
        name: 'sendingsModeration',
        component: () => {
          return import('@/pages/SendingsModeration')
        },

        meta: {
          auth: true,
          nav: true,
          navIcon: 'verified_user',
          permission: [ 'advanced.sendingsModeration.get' ],
          permissionAccept: permissionPresets.resellerUp,
          suffix: 'counter'
        }
      },

      {
        path: 'routes',
        name: 'routes',
        component: () => {
          return import('@/pages/Routes')
        },

        meta: {
          auth: true,
          nav: true,
          navType: 'group',
          navIcon: 'merge_type',
          permission: [
            'advanced.providers.get',
            'advanced.providerGroups.get',
            'advanced.routingRules.get',
            'advanced.routingGroups.get',
            'advanced.servers.get',
            'advanced.credentials.get'
          ],
          permissionAccept: permissionPresets.true
        },

        children: [
          {
            path: 'providers',
            name: 'providers',
            component: () => {
              return import('@/pages/Providers')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.providers.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'providers.single',

                meta: {
                  auth: true,
                  permission: 'advanced.providers.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'providerGroups',
            name: 'providerGroups',
            component: () => {
              return import('@/pages/ProviderGroups')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.providerGroups.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'providerGroups.single',

                meta: {
                  auth: true,
                  permission: 'advanced.providerGroups.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'routingRules',
            name: 'routingRules',
            component: () => {
              return import('@/pages/RoutingRules')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.routingRules.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'routingRules.single',

                meta: {
                  auth: true,
                  permission: 'advanced.routingRules.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'routingGroups',
            name: 'routingGroups',
            component: () => {
              return import('@/pages/RoutingGroups')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.routingGroups.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'routingGroups.single',

                meta: {
                  auth: true,
                  permission: 'advanced.routingGroups.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'servers',
            name: 'servers',
            component: () => {
              return import('@/pages/Servers')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.servers.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'servers.single',

                meta: {
                  auth: true,
                  permission: 'advanced.servers.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'credentials',
            name: 'credentials',
            component: () => {
              return import('@/pages/Credentials')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.credentials.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'credentials.single',

                meta: {
                  auth: true,
                  permission: 'advanced.credentials.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          }
        ]
      },

      {
        path: 'messageProcessing',
        name: 'messageProcessing',
        component: () => {
          return import('@/pages/MessageProcessing')
        },

        meta: {
          auth: true,
          nav: true,
          navType: 'group',
          navIcon: 'message',
          permission: [
            'advanced.messageRules.get',
            'advanced.messageRuleGroups.get',
            'advanced.keywords.get'
          ],
          permissionAccept: true
        },

        children: [
          {
            path: 'messageRules',
            name: 'messageRules',
            component: () => {
              return import('@/pages/MessageRuleTemplates')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.messageRules.get',
              permissionAccept: true
            },

            children: [
              {
                path: ':id',
                name: 'messageRules.single',

                meta: {
                  auth: true,
                  permission: 'advanced.messageRules.get',
                  permissionAccept: true
                }
              }
            ]
          },

          {
            path: 'messageRuleGroups',
            name: 'messageRuleGroups',
            component: () => {
              return import('@/pages/MessageRuleGroups')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.messageRuleGroups.get',
              permissionAccept: true
            },

            children: [
              {
                path: ':id',
                name: 'messageRuleGroups.single',

                meta: {
                  auth: true,
                  permission: 'advanced.messageRuleGroups.get',
                  permissionAccept: true
                }
              }
            ]
          },

          {
            path: 'keywordLists',
            name: 'keywordLists',
            component: () => {
              return import('@/pages/KeywordLists')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.keywords.get',
              permissionAccept: true
            },

            children: [
              {
                path: ':id',
                name: 'keywordLists.single',

                meta: {
                  auth: true,
                  permission: 'advanced.keywords.get',
                  permissionAccept: true
                }
              }
            ]
          }
        ]
      },

      {
        path: 'documents',
        name: 'documents',
        component: () => {
          return import('@/pages/Documents')
        },

        meta: {
          auth: true,
          nav: true,
          navType: 'group',
          navIcon: 'class',
          permission: [
            'advanced.requisites.get',
            'advanced.companies.get',
            'advanced.contracts.get'
          ],
          permissionAccept: permissionPresets.resellerUp
        },

        children: [
          {
            path: 'requisites',
            name: 'requisites',
            component: () => {
              return import('@/pages/Requisites')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.requisites.get',
              permissionAccept: permissionPresets.resellerUp
            },

            children: [
              {
                path: ':id',
                name: 'requisites.single',

                meta: {
                  auth: true,
                  permission: 'advanced.requisites.get',
                  permissionAccept: permissionPresets.resellerUp
                }
              }
            ]
          },

          {
            path: 'companies',
            name: 'companies',
            component: () => {
              return import('@/pages/Companies')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.companies.get',
              permissionAccept: permissionPresets.resellerUp
            },

            children: [
              {
                path: ':id',
                name: 'companies.single',

                meta: {
                  auth: true,
                  permission: 'advanced.companies.get',
                  permissionAccept: permissionPresets.resellerUp
                }
              }
            ]
          },

          {
            path: 'contracts',
            name: 'contracts',
            component: () => {
              return import('@/pages/Contracts')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.contracts.get',
              permissionAccept: permissionPresets.resellerUp
            },

            children: [
              {
                path: ':id',
                name: 'contracts.single',

                meta: {
                  auth: true,
                  permission: 'advanced.contracts.get',
                  permissionAccept: permissionPresets.resellerUp
                }
              }
            ]
          }
        ]
      },

      {
        path: 'settings',
        name: 'settings',
        component: () => {
          return import('@/pages/Settings')
        },

        meta: {
          auth: true,
          nav: true,
          navIcon: 'settings',
          permission: 'advanced.settingsSite.get',
          permissionAccept: permissionPresets.resellerUp
        },

        children: [
          {
            path: ':UserId',
            name: 'settings.single',

            meta: {
              auth: true,
              permission: 'advanced.settingsSite.get',
              permissionAccept: permissionPresets.resellerUp
            }
          }
        ]
      },

      {
        path: 'notifications',
        name: 'notifications',
        component: () => {
          return import('@/pages/Notifications')
        },

        meta: {
          auth: true,
          nav: true,
          navIcon: 'notifications',
          permission: 'advanced.notifications.get',
          permissionAccept: permissionPresets.admin
        }
      },

      {
        path: '/other',
        name: 'other',
        component: () => {
          return import('@/pages/Other')
        },

        meta: {
          auth: true,
          nav: true,
          navType: 'group',
          navIcon: 'more_horiz',
          permission: [
            'advanced.dictionaries.get',
            'advanced.tokens.get',
            'advanced.yclients.get',
            'advanced.eventsHistory.get',
            `advanced.${Services['country-regions']}.get`
          ],
          permissionAccept: permissionPresets.true
        },

        children: [
          {
            path: 'yclients',
            name: 'yclients',
            component: () => {
              return import('@/pages/YClients')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.yclients.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'yclients.single',

                meta: {
                  auth: true,
                  permission: 'advanced.yclients.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'tokens',
            name: 'tokens',
            component: () => {
              return import('@/pages/Tokens')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.tokens.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'tokens.single',

                meta: {
                  auth: true,
                  permission: 'advanced.tokens.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: 'dictionaries',
            name: 'dictionaries',
            component: () => {
              return import('@/pages/Dictionaries')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.dictionaries.get',
              permissionAccept: permissionPresets.true
            }
          },

          {
            path: 'eventsHistory',
            name: 'eventsHistory',
            component: () => {
              return import('@/pages/EventsHistory')
            },

            meta: {
              auth: true,
              nav: true,
              permission: 'advanced.eventsHistory.get',
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: 'eventsHistory.single',

                meta: {
                  auth: true,
                  permission: 'advanced.eventsHistory.get',
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          },

          {
            path: Services['country-regions'],
            name: Services['country-regions'],
            component: () => {
              return import('@/pages/CountryRegions')
            },

            meta: {
              auth: true,
              nav: true,
              permission: `advanced.${Services['country-regions']}.get`,
              permissionAccept: permissionPresets.true
            },

            children: [
              {
                path: ':id',
                name: `${Services['country-regions']}.single`,

                meta: {
                  auth: true,
                  permission: `advanced.${Services['country-regions']}.get`,
                  permissionAccept: permissionPresets.true
                }
              }
            ]
          }
        ]
      }
    ]
  },

  // files
  {
    path: '/files',
    name: 'files',
    component: () => {
      return import('@/pages/Files')
    },

    meta: {
      auth: true,
      nav: true,
      navIcon: 'folder',
      permission: 'advanced.storage.get',
      permissionAccept: permissionPresets.meUp
    }
  },

  // documentation
  {
    path: '/documentation',
    name: 'documentation',
    component: () => {
      return import('@/pages/Documentation')
    },

    meta: {
      nav: true,
      navIcon: 'help',
      params: {
        category: 'platform',
        file: 'instruction'
      }
    },

    children: [
      {
        path: ':category',
        name: 'documentation.category',

        children: [
          {
            path: ':file',
            name: 'documentation.file'
          }
        ]
      }
    ]
  },

  // login
  {
    path: '/login',
    name: 'login',
    component: () => {
      return import('@/pages/Login')
    },

    meta: {
      guest: true
    }
  },

  // registration
  {
    path: '/registration',
    name: 'registration',
    component: () => {
      return import('@/pages/Registration')
    },

    meta: {
      guest: true
    }
  },

  // recover
  {
    path: '/recover',
    name: 'recover',
    component: () => {
      return import('@/pages/Recover')
    },

    meta: {
      guest: true
    },

    children: [
      {
        path: ':key',
        name: 'recover.key',

        meta: {
          guest: true
        }
      }
    ]
  },

  // dashboard
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => {
      return import('@/pages/Dashboard')
    },

    meta: {
      auth: true
    }
  },

  // account
  {
    path: '/account',
    name: 'account',
    component: () => {
      return import('@/pages/Account')
    },

    meta: {
      auth: true
    }
  },

  // support
  {
    path: '/support',
    name: 'support',
    component: () => {
      return import('@/pages/Support')
    },

    meta: {
      auth: true,
      handler({ store, from, next }) {
        if (!store.getters['settings/global'].contacts) {
          let redirect = { name: 'home' }
          if (from && from.name) {
            redirect = false
          }
          next(redirect)

          return true
        }
      }
    }
  },

  // debug
  {
    path: '/debug',
    name: 'debug',
    component: () => {
      return import('@/pages/Debug')
    }
  },

  // playground
  {
    path: '/playground',
    name: 'playground',
    redirect: {
      name: 'playground.components.squircle'
    },
    component: () => {
      return import('@/pages/playground')
    },

    children: [
      {
        path: 'components/squircle',
        name: 'playground.components.squircle',
        component: () => {
          return import('@/pages/playground/components/squircle')
        }
      },
      {
        path: 'components/sticker',
        name: 'playground.components.sticker',
        component: () => {
          return import('@/pages/playground/components/sticker')
        }
      },
      {
        path: 'components/button',
        name: 'playground.components.button',
        component: () => {
          return import('@/pages/playground/components/button')
        }
      },
      {
        path: 'components/tag',
        name: 'playground.components.tag',
        component: () => {
          return import('@/pages/playground/components/tag')
        }
      },
      {
        path: 'components/g/select',
        name: 'playground.components.g.select',
        component: () => {
          return import('@/pages/playground/components/g/select')
        }
      },
      {
        path: 'components/g/text-field',
        name: 'playground.components.g.text-field',
        component: () => {
          return import('@/pages/playground/components/g/text-field')
        }
      },
      {
        path: 'components/g/textarea',
        name: 'playground.components.g.textarea',
        component: () => {
          return import('@/pages/playground/components/g/textarea')
        }
      },
      {
        path: 'components/g/snackbar',
        name: 'playground.components.g.snackbar',
        component: () => {
          return import('@/pages/playground/components/g/snackbar')
        }
      },
      {
        path: 'services/contactLists',
        name: 'playground.services.contactLists',
        component: () => {
          return import('@/pages/playground/services/contactLists')
        }
      }
    ]
  },

  // pay
  {
    path: '/pay',
    name: 'pay',
    component: () => {
      return import('@/pages/Pay')
    },

    children: [
      {
        path: ':owner',
        name: 'pay.owner'
      }
    ]
  },

  // /components
  {
    path: '/components',
    redirect: '/sendernames'
  },

  // Эти два роута должны быть в конце,
  // иначе роуты без авторизации или статуса гостя
  // будут перехвачены редиректом на /create
  // home
  {
    path: '/',
    name: 'home',
    redirect: '/create'
  },

  // /*
  {
    path: '/*',
    redirect: '/create'
  }
]
